import { Text } from "@alpacahq/ui/old";

import type { FAQItem } from "../../../../../components/common/FAQ";

export const BUSINESS_INFO_FAQ: FAQItem[] = [
  {
    question: "What is a Business Registration Number?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        A Business Registration Number (BRN) is a unique identifier issued by a
        government when a business is registered. It is used for tax filing,
        permits, bank accounts, and legal transactions. The name and format vary
        by country, such as the EIN in the US and CRN in the UK.
        <br />
        Generally, it is different from a Tax ID Number for the business, but it
        may sometimes be the same.
      </Text>
    ),
  },
  {
    question:
      "What is the minimum deposit to open a business brokerage account?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        A minimum deposit of $30,000 is required. However, there's no charge to
        open a business brokerage account.
      </Text>
    ),
  },
  {
    question:
      "Can I link my business brokerage account to my business checking account?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        Yes, it is required for a business brokerage account to use a business
        bank account for funding. Additionally, the names and addresses on both
        the brokerage account and the business checking account must match to
        ensure proper account linking and compliance.
      </Text>
    ),
  },
  {
    question: "My business is home-based, what address should I use? ",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        If you're a sole proprietor or a small business, your home address can
        typically serve as the official business address, provided that you use
        it consistently for all your business accounts and registrations.
      </Text>
    ),
  },
  {
    question: "Can I use a P.O. Box as my business address?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        Alpaca requires a physical (business or residential) address on file for
        businesses. This may be a place of business or the residential address
        of an Ultimate Beneficial Owner or Authorized Person where business is
        conducted.
      </Text>
    ),
  },
  {
    question: "What is a Business Tax ID? ",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        For US business, it is the Employer Identification Number (EIN), a
        unique nine-digit number assigned by the Internal Revenue Service (IRS)
        to identify a business entity for tax purposes.
        <br />
        International accounts need to provide their own applicable Business Tax
        IDs (e.g., VAT numbers, TINs) that is on their official
        government-issued documents.
      </Text>
    ),
  },
  {
    question: "What is 501(a) of the Internal Revenue Code? ",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        Section 501(a) of the Internal Revenue Code (IRC) is part of the U.S.
        tax law that grants tax-exempt status to certain types of organizations.
      </Text>
    ),
  },
  {
    question: "What is a FATCA institution? ",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        A FATCA institution refers to a financial institution that is subject to
        the Foreign Account Tax Compliance Act (FATCA), a U.S. law designed to
        combat tax evasion by U.S. taxpayers holding accounts in foreign
        financial institutions. The FATCA requires foreign institutions to
        report information about accounts held by U.S. taxpayers to the U.S.
        government.
      </Text>
    ),
  },
];
